import Vue from 'vue'

/**
 *
 * @param {*} params
 */
export const getComBasic = params => {
  return Vue.fetch.post('/apiv1/com_log/basic', params)
}

export const getComlogs = params => {
  return Vue.fetch.post('/apiv1/com_log/logs', params)
}

export const getComRelevant = params => {
  return Vue.fetch.post('/apiv1/com_log/relevant', params)
}



// WEBPACK FOOTER //
// ./src/services/communicationLogApi.js